import {
  Grid,
  Table,
  TableBody,
  TableCell,
  TableRow,
  Tooltip,
  TooltipProps,
  styled,
  tooltipClasses,
} from "@mui/material";
import MDBox from "components/MDBox";
import dayjs from "dayjs";
import { JobPhase } from "generated/graphql";
import HelpIcon from "@mui/icons-material/Help";
import utc from "dayjs/plugin/utc";
import localizedFormat from "dayjs/plugin/localizedFormat";
import { useFieldArray, useFormContext } from "react-hook-form";
import { UpdateWorkOrderInputSchema } from "DDD/action-objects/WorkOrderItemsUpdate";
import FormField from "components/FormField/FormField";

dayjs.extend(utc);
dayjs.extend(localizedFormat);
const CustomWidthTooltip = styled(({ className, ...props }: TooltipProps) => (
  <Tooltip {...props} classes={{ popper: className }} />
))({
  [`& .${tooltipClasses.tooltip}`]: {
    maxWidth: 500,
  },
});
const JobPhaseScheduleSection = ({ data }: { data: JobPhase }) => {
  const { scheduleBlocks } = data;
  const { control, register } = useFormContext<UpdateWorkOrderInputSchema>();

  const { fields: scheduleFields } = useFieldArray({
    control,
    name: "schedules",
  });

  return (
    <Grid item xs={12} className="no-break">
      <Table
        sx={{
          "& .MuiTableCell-root": {
            padding: "5px",
            borderColor: "rgba(0, 0, 0, 0.08)",
            fontSize: "0.95rem",
            lineHeight: 1.2,
          },
          "& .schedule-header": {
            fontSize: "1rem",
            fontWeight: 700,
            backgroundColor: "#f5f5f5",
          },
          "@media print": {
            "& .MuiTableCell-root": {
              padding: "5px",
            },
            "& .schedule-header": {
              fontSize: "1rem",
            },
          },
        }}
      >
        <TableBody>
          <TableRow>
            <TableCell className="schedule-header">Date</TableCell>
            <TableCell className="schedule-header">Start Time</TableCell>
            <TableCell className="schedule-header">Hours</TableCell>
            <TableCell className="schedule-header">
              <MDBox display="flex" gap={1} alignItems="center" color="#000">
                Estimated Material
                <CustomWidthTooltip
                  title={
                    <>
                      <p>
                        Estimated Material is calculated based on the number of hours scheduled to a
                        specific day compared to the overall job hours.
                      </p>
                    </>
                  }
                  placement="top"
                >
                  <HelpIcon className="no-print" fontSize="small" />
                </CustomWidthTooltip>
              </MDBox>
            </TableCell>
          </TableRow>
          {scheduleFields?.map((field, i) => {
            const block = scheduleBlocks[i];
            return (
              <TableRow key={field.id}>
                <TableCell>
                  {dayjs.utc(block?.scheduledAt).local().format("MMMM D, YYYY")}
                </TableCell>
                <TableCell>{dayjs.utc(block?.scheduledAt).local().format("h:mmA")}</TableCell>
                <TableCell>{block?.blockLength}</TableCell>
                <TableCell
                  sx={{
                    display: "none",
                    "@media print": {
                      display: "table-cell",
                    },
                  }}
                >
                  {(block?.estimatedMaterialOverride || block?.estimatedMaterial)?.toFixed(1)}
                </TableCell>
                <TableCell className="no-print">
                  <FormField
                    {...register(`schedules.${i}.estimatedMaterialOverride`, {
                      valueAsNumber: true,
                    })}
                  />
                </TableCell>
              </TableRow>
            );
          })}
        </TableBody>
      </Table>
    </Grid>
  );
};

export default JobPhaseScheduleSection;
